export default __webpack_public_path__ + "static/media/node-.10354602.svg";